// extracted by mini-css-extract-plugin
export default {"price":"constructor-price_price__RFPBY","container":"constructor-price_container__HMEOS","modal":"constructor-price_modal__aLuxT"};